import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addJob } from 'slice/jobSlice';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddJob = () => {
  const [formData, setFormData] = useState({
    jobTitle: '',
    description: '',
    experience: '',
    skill: '',
    education: '',
    location: ''
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.job);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await dispatch(addJob(formData));
      const payload = res.payload;

      if (payload?.id) {
        toast.success('Job posted successfully!');
        setTimeout(() => navigate('/jobs'), 2000);
      } else {
        toast.error(payload?.message || 'Failed to post job!');
      }
    } catch (err) {
      console.error('Post job error:', err);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Post a Job</h4>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row mx-4 mt-5">
          <div className="col-sm-4 mt-2">
            <label htmlFor="jobTitle" className="adminlables">Job Title</label>
            <input
              type="text"
              id="jobTitle"
              name="jobTitle"
              value={formData.jobTitle}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-4 mt-2">
            <label htmlFor="experience" className="adminlables">Experience</label>
            <input
              type="text"
              id="experience"
              name="experience"
              value={formData.experience}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-4 mt-2">
            <label htmlFor="skill" className="adminlables">Skill</label>
            <input
              type="text"
              id="skill"
              name="skill"
              value={formData.skill}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-4 mt-2">
            <label htmlFor="education" className="adminlables">Education</label>
            <input
              type="text"
              id="education"
              name="education"
              value={formData.education}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-4 mt-2">
            <label htmlFor="location" className="adminlables">Location</label>
            <input
              type="text"
              id="location"
              name="location"
              value={formData.location}
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-sm-12 mt-4">
            <label htmlFor="description" className="adminlables">Job Description</label>
            <textarea
              id="description"
              rows={5}
              name="description"
              value={formData.description}
              className="form-control"
              onChange={handleChange}
              required
            ></textarea>
          </div>
        </div>

        <div className="mt-5 text-right mx-4">
          <button className="btn btn-lg addbtn" disabled={loading}>
            Post Job
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddJob;
